// Projects.js
import React,{useEffect} from 'react';
import '../styles/project.css'; // Make sure to have the correct path to your CSS file

function Projects() {

  useEffect(() => {
    const handleMouseMove = (event) => {
      const { clientX, clientY } = event;
      const moveX = (clientX / window.innerWidth) * 100;
      const moveY = (clientY / window.innerHeight) * 100;
      document.documentElement.style.setProperty('--mouse-x', `${moveX}%`);
      document.documentElement.style.setProperty('--mouse-y', `${moveY}%`);
    };

    document.addEventListener('mousemove', handleMouseMove);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  const projects = [
    {
      id: 1,
      title: 'Voice Controlled Rover Using Machine Learning and Raspberry Pi',
      description: 'M.Tech major project (2022). Interface to control a robotic car by voice commands which also responds like a personal voice assistant.',
      year: '2022'
    },
    // ... Add more projects here
  ];


  return (
    <div className="projects-section">
      <div className="background-animation"></div> {/* CSS Doodle for animated stars background */}
      <div className="projects-container">
        {projects.map(project => (
          <div key={project.id} className="project-card">
            <h3>{project.title}</h3>
            <p>{project.description}</p>
            <p>Year: {project.year}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Projects;
